// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _getV1PurchaseSettings = async (url: string, request: Types.GetV1PurchaseSettingsRequest): Promise<Types.GetV1PurchaseSettingsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseSettingsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-settings/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseSettings: Api['getV1PurchaseSettings'] = async (request: Types.GetV1PurchaseSettingsRequest): Promise<Types.GetV1PurchaseSettingsResponses> => {
  return await _getV1PurchaseSettings(baseUrl, request)
}
const _patchV1PurchaseSettingsId = async (url: string, request: Types.PatchV1PurchaseSettingsIdRequest): Promise<Types.PatchV1PurchaseSettingsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-settings/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1PurchaseSettingsId: Api['patchV1PurchaseSettingsId'] = async (request: Types.PatchV1PurchaseSettingsIdRequest): Promise<Types.PatchV1PurchaseSettingsIdResponses> => {
  return await _patchV1PurchaseSettingsId(baseUrl, request)
}
const _postV1DemandPlanningSummary = async (url: string, request: Types.PostV1DemandPlanningSummaryRequest): Promise<Types.PostV1DemandPlanningSummaryResponses> => {
  const queryParameters: (keyof Types.PostV1DemandPlanningSummaryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/demand-planning/summary?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DemandPlanningSummary: Api['postV1DemandPlanningSummary'] = async (request: Types.PostV1DemandPlanningSummaryRequest): Promise<Types.PostV1DemandPlanningSummaryResponses> => {
  return await _postV1DemandPlanningSummary(baseUrl, request)
}
const _postV1DemandPlanningDetail = async (url: string, request: Types.PostV1DemandPlanningDetailRequest): Promise<Types.PostV1DemandPlanningDetailResponses> => {
  const queryParameters: (keyof Types.PostV1DemandPlanningDetailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/demand-planning/detail?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DemandPlanningDetail: Api['postV1DemandPlanningDetail'] = async (request: Types.PostV1DemandPlanningDetailRequest): Promise<Types.PostV1DemandPlanningDetailResponses> => {
  return await _postV1DemandPlanningDetail(baseUrl, request)
}
const _postV1DemandPlanningDemand = async (url: string, request: Types.PostV1DemandPlanningDemandRequest): Promise<Types.PostV1DemandPlanningDemandResponses> => {
  const queryParameters: (keyof Types.PostV1DemandPlanningDemandRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/demand-planning/demand?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DemandPlanningDemand: Api['postV1DemandPlanningDemand'] = async (request: Types.PostV1DemandPlanningDemandRequest): Promise<Types.PostV1DemandPlanningDemandResponses> => {
  return await _postV1DemandPlanningDemand(baseUrl, request)
}
const _postV1DemandPlanningMaterials = async (url: string, request: Types.PostV1DemandPlanningMaterialsRequest): Promise<Types.PostV1DemandPlanningMaterialsResponses> => {
  const queryParameters: (keyof Types.PostV1DemandPlanningMaterialsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/demand-planning/materials?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DemandPlanningMaterials: Api['postV1DemandPlanningMaterials'] = async (request: Types.PostV1DemandPlanningMaterialsRequest): Promise<Types.PostV1DemandPlanningMaterialsResponses> => {
  return await _postV1DemandPlanningMaterials(baseUrl, request)
}
const _postV1DemandPlanningGenerateExcel = async (url: string, request: Types.PostV1DemandPlanningGenerateExcelRequest): Promise<Types.PostV1DemandPlanningGenerateExcelResponses> => {
  const queryParameters: (keyof Types.PostV1DemandPlanningGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/demand-planning/generate-excel?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DemandPlanningGenerateExcel: Api['postV1DemandPlanningGenerateExcel'] = async (request: Types.PostV1DemandPlanningGenerateExcelRequest): Promise<Types.PostV1DemandPlanningGenerateExcelResponses> => {
  return await _postV1DemandPlanningGenerateExcel(baseUrl, request)
}
const _postV1PurchaseRequests = async (url: string, request: Types.PostV1PurchaseRequestsRequest): Promise<Types.PostV1PurchaseRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseRequests: Api['postV1PurchaseRequests'] = async (request: Types.PostV1PurchaseRequestsRequest): Promise<Types.PostV1PurchaseRequestsResponses> => {
  return await _postV1PurchaseRequests(baseUrl, request)
}
const _getV1PurchaseRequests = async (url: string, request: Types.GetV1PurchaseRequestsRequest): Promise<Types.GetV1PurchaseRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseRequests: Api['getV1PurchaseRequests'] = async (request: Types.GetV1PurchaseRequestsRequest): Promise<Types.GetV1PurchaseRequestsResponses> => {
  return await _getV1PurchaseRequests(baseUrl, request)
}
const _postV1PurchaseRequestsSaveDraft = async (url: string, request: Types.PostV1PurchaseRequestsSaveDraftRequest): Promise<Types.PostV1PurchaseRequestsSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseRequestsSaveDraft: Api['postV1PurchaseRequestsSaveDraft'] = async (request: Types.PostV1PurchaseRequestsSaveDraftRequest): Promise<Types.PostV1PurchaseRequestsSaveDraftResponses> => {
  return await _postV1PurchaseRequestsSaveDraft(baseUrl, request)
}
const _getV1PurchaseRequestsId = async (url: string, request: Types.GetV1PurchaseRequestsIdRequest): Promise<Types.GetV1PurchaseRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseRequestsId: Api['getV1PurchaseRequestsId'] = async (request: Types.GetV1PurchaseRequestsIdRequest): Promise<Types.GetV1PurchaseRequestsIdResponses> => {
  return await _getV1PurchaseRequestsId(baseUrl, request)
}
const _putV1PurchaseRequestsId = async (url: string, request: Types.PutV1PurchaseRequestsIdRequest): Promise<Types.PutV1PurchaseRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseRequestsId: Api['putV1PurchaseRequestsId'] = async (request: Types.PutV1PurchaseRequestsIdRequest): Promise<Types.PutV1PurchaseRequestsIdResponses> => {
  return await _putV1PurchaseRequestsId(baseUrl, request)
}
const _deleteV1PurchaseRequestsId = async (url: string, request: Types.DeleteV1PurchaseRequestsIdRequest): Promise<Types.DeleteV1PurchaseRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseRequestsId: Api['deleteV1PurchaseRequestsId'] = async (request: Types.DeleteV1PurchaseRequestsIdRequest): Promise<Types.DeleteV1PurchaseRequestsIdResponses> => {
  return await _deleteV1PurchaseRequestsId(baseUrl, request)
}
const _patchV1PurchaseRequestsStatusId = async (url: string, request: Types.PatchV1PurchaseRequestsStatusIdRequest): Promise<Types.PatchV1PurchaseRequestsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1PurchaseRequestsStatusId: Api['patchV1PurchaseRequestsStatusId'] = async (request: Types.PatchV1PurchaseRequestsStatusIdRequest): Promise<Types.PatchV1PurchaseRequestsStatusIdResponses> => {
  return await _patchV1PurchaseRequestsStatusId(baseUrl, request)
}
const _postV1PurchaseRequestsAddApprover = async (url: string, request: Types.PostV1PurchaseRequestsAddApproverRequest): Promise<Types.PostV1PurchaseRequestsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseRequestsAddApprover: Api['postV1PurchaseRequestsAddApprover'] = async (request: Types.PostV1PurchaseRequestsAddApproverRequest): Promise<Types.PostV1PurchaseRequestsAddApproverResponses> => {
  return await _postV1PurchaseRequestsAddApprover(baseUrl, request)
}
const _putV1PurchaseRequestsApprovalStatusId = async (url: string, request: Types.PutV1PurchaseRequestsApprovalStatusIdRequest): Promise<Types.PutV1PurchaseRequestsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseRequestsApprovalStatusId: Api['putV1PurchaseRequestsApprovalStatusId'] = async (request: Types.PutV1PurchaseRequestsApprovalStatusIdRequest): Promise<Types.PutV1PurchaseRequestsApprovalStatusIdResponses> => {
  return await _putV1PurchaseRequestsApprovalStatusId(baseUrl, request)
}
const _postV1PurchaseRequestsItems = async (url: string, request: Types.PostV1PurchaseRequestsItemsRequest): Promise<Types.PostV1PurchaseRequestsItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseRequestsItems: Api['postV1PurchaseRequestsItems'] = async (request: Types.PostV1PurchaseRequestsItemsRequest): Promise<Types.PostV1PurchaseRequestsItemsResponses> => {
  return await _postV1PurchaseRequestsItems(baseUrl, request)
}
const _getV1PurchaseRequestsItemsId = async (url: string, request: Types.GetV1PurchaseRequestsItemsIdRequest): Promise<Types.GetV1PurchaseRequestsItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseRequestsItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseRequestsItemsId: Api['getV1PurchaseRequestsItemsId'] = async (request: Types.GetV1PurchaseRequestsItemsIdRequest): Promise<Types.GetV1PurchaseRequestsItemsIdResponses> => {
  return await _getV1PurchaseRequestsItemsId(baseUrl, request)
}
const _putV1PurchaseRequestsItemsId = async (url: string, request: Types.PutV1PurchaseRequestsItemsIdRequest): Promise<Types.PutV1PurchaseRequestsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseRequestsItemsId: Api['putV1PurchaseRequestsItemsId'] = async (request: Types.PutV1PurchaseRequestsItemsIdRequest): Promise<Types.PutV1PurchaseRequestsItemsIdResponses> => {
  return await _putV1PurchaseRequestsItemsId(baseUrl, request)
}
const _deleteV1PurchaseRequestsItemsId = async (url: string, request: Types.DeleteV1PurchaseRequestsItemsIdRequest): Promise<Types.DeleteV1PurchaseRequestsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseRequestsItemsId: Api['deleteV1PurchaseRequestsItemsId'] = async (request: Types.DeleteV1PurchaseRequestsItemsIdRequest): Promise<Types.DeleteV1PurchaseRequestsItemsIdResponses> => {
  return await _deleteV1PurchaseRequestsItemsId(baseUrl, request)
}
const _getV1PurchaseRequestsGenerateExcel = async (url: string, request: Types.GetV1PurchaseRequestsGenerateExcelRequest): Promise<Types.GetV1PurchaseRequestsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseRequestsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/purchase-requests/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseRequestsGenerateExcel: Api['getV1PurchaseRequestsGenerateExcel'] = async (request: Types.GetV1PurchaseRequestsGenerateExcelRequest): Promise<Types.GetV1PurchaseRequestsGenerateExcelResponses> => {
  return await _getV1PurchaseRequestsGenerateExcel(baseUrl, request)
}
const _postV1PurchaseRequestsImport = async (url: string, request: Types.PostV1PurchaseRequestsImportRequest): Promise<Types.PostV1PurchaseRequestsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-requests/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseRequestsImport: Api['postV1PurchaseRequestsImport'] = async (request: Types.PostV1PurchaseRequestsImportRequest): Promise<Types.PostV1PurchaseRequestsImportResponses> => {
  return await _postV1PurchaseRequestsImport(baseUrl, request)
}
const _postV1PurchaseAgreements = async (url: string, request: Types.PostV1PurchaseAgreementsRequest): Promise<Types.PostV1PurchaseAgreementsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseAgreements: Api['postV1PurchaseAgreements'] = async (request: Types.PostV1PurchaseAgreementsRequest): Promise<Types.PostV1PurchaseAgreementsResponses> => {
  return await _postV1PurchaseAgreements(baseUrl, request)
}
const _getV1PurchaseAgreements = async (url: string, request: Types.GetV1PurchaseAgreementsRequest): Promise<Types.GetV1PurchaseAgreementsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseAgreementsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseAgreements: Api['getV1PurchaseAgreements'] = async (request: Types.GetV1PurchaseAgreementsRequest): Promise<Types.GetV1PurchaseAgreementsResponses> => {
  return await _getV1PurchaseAgreements(baseUrl, request)
}
const _postV1PurchaseAgreementsSaveDraft = async (url: string, request: Types.PostV1PurchaseAgreementsSaveDraftRequest): Promise<Types.PostV1PurchaseAgreementsSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseAgreementsSaveDraft: Api['postV1PurchaseAgreementsSaveDraft'] = async (request: Types.PostV1PurchaseAgreementsSaveDraftRequest): Promise<Types.PostV1PurchaseAgreementsSaveDraftResponses> => {
  return await _postV1PurchaseAgreementsSaveDraft(baseUrl, request)
}
const _getV1PurchaseAgreementsId = async (url: string, request: Types.GetV1PurchaseAgreementsIdRequest): Promise<Types.GetV1PurchaseAgreementsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseAgreementsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseAgreementsId: Api['getV1PurchaseAgreementsId'] = async (request: Types.GetV1PurchaseAgreementsIdRequest): Promise<Types.GetV1PurchaseAgreementsIdResponses> => {
  return await _getV1PurchaseAgreementsId(baseUrl, request)
}
const _putV1PurchaseAgreementsId = async (url: string, request: Types.PutV1PurchaseAgreementsIdRequest): Promise<Types.PutV1PurchaseAgreementsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseAgreementsId: Api['putV1PurchaseAgreementsId'] = async (request: Types.PutV1PurchaseAgreementsIdRequest): Promise<Types.PutV1PurchaseAgreementsIdResponses> => {
  return await _putV1PurchaseAgreementsId(baseUrl, request)
}
const _deleteV1PurchaseAgreementsId = async (url: string, request: Types.DeleteV1PurchaseAgreementsIdRequest): Promise<Types.DeleteV1PurchaseAgreementsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseAgreementsId: Api['deleteV1PurchaseAgreementsId'] = async (request: Types.DeleteV1PurchaseAgreementsIdRequest): Promise<Types.DeleteV1PurchaseAgreementsIdResponses> => {
  return await _deleteV1PurchaseAgreementsId(baseUrl, request)
}
const _patchV1PurchaseAgreementsStatusId = async (url: string, request: Types.PatchV1PurchaseAgreementsStatusIdRequest): Promise<Types.PatchV1PurchaseAgreementsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1PurchaseAgreementsStatusId: Api['patchV1PurchaseAgreementsStatusId'] = async (request: Types.PatchV1PurchaseAgreementsStatusIdRequest): Promise<Types.PatchV1PurchaseAgreementsStatusIdResponses> => {
  return await _patchV1PurchaseAgreementsStatusId(baseUrl, request)
}
const _postV1PurchaseAgreementsAddApprover = async (url: string, request: Types.PostV1PurchaseAgreementsAddApproverRequest): Promise<Types.PostV1PurchaseAgreementsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseAgreementsAddApprover: Api['postV1PurchaseAgreementsAddApprover'] = async (request: Types.PostV1PurchaseAgreementsAddApproverRequest): Promise<Types.PostV1PurchaseAgreementsAddApproverResponses> => {
  return await _postV1PurchaseAgreementsAddApprover(baseUrl, request)
}
const _putV1PurchaseAgreementsApprovalStatusId = async (url: string, request: Types.PutV1PurchaseAgreementsApprovalStatusIdRequest): Promise<Types.PutV1PurchaseAgreementsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseAgreementsApprovalStatusId: Api['putV1PurchaseAgreementsApprovalStatusId'] = async (request: Types.PutV1PurchaseAgreementsApprovalStatusIdRequest): Promise<Types.PutV1PurchaseAgreementsApprovalStatusIdResponses> => {
  return await _putV1PurchaseAgreementsApprovalStatusId(baseUrl, request)
}
const _postV1PurchaseAgreementsItems = async (url: string, request: Types.PostV1PurchaseAgreementsItemsRequest): Promise<Types.PostV1PurchaseAgreementsItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseAgreementsItems: Api['postV1PurchaseAgreementsItems'] = async (request: Types.PostV1PurchaseAgreementsItemsRequest): Promise<Types.PostV1PurchaseAgreementsItemsResponses> => {
  return await _postV1PurchaseAgreementsItems(baseUrl, request)
}
const _getV1PurchaseAgreementsItemsId = async (url: string, request: Types.GetV1PurchaseAgreementsItemsIdRequest): Promise<Types.GetV1PurchaseAgreementsItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseAgreementsItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseAgreementsItemsId: Api['getV1PurchaseAgreementsItemsId'] = async (request: Types.GetV1PurchaseAgreementsItemsIdRequest): Promise<Types.GetV1PurchaseAgreementsItemsIdResponses> => {
  return await _getV1PurchaseAgreementsItemsId(baseUrl, request)
}
const _putV1PurchaseAgreementsItemsId = async (url: string, request: Types.PutV1PurchaseAgreementsItemsIdRequest): Promise<Types.PutV1PurchaseAgreementsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseAgreementsItemsId: Api['putV1PurchaseAgreementsItemsId'] = async (request: Types.PutV1PurchaseAgreementsItemsIdRequest): Promise<Types.PutV1PurchaseAgreementsItemsIdResponses> => {
  return await _putV1PurchaseAgreementsItemsId(baseUrl, request)
}
const _deleteV1PurchaseAgreementsItemsId = async (url: string, request: Types.DeleteV1PurchaseAgreementsItemsIdRequest): Promise<Types.DeleteV1PurchaseAgreementsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseAgreementsItemsId: Api['deleteV1PurchaseAgreementsItemsId'] = async (request: Types.DeleteV1PurchaseAgreementsItemsIdRequest): Promise<Types.DeleteV1PurchaseAgreementsItemsIdResponses> => {
  return await _deleteV1PurchaseAgreementsItemsId(baseUrl, request)
}
const _getV1PurchaseAgreementsGenerateExcel = async (url: string, request: Types.GetV1PurchaseAgreementsGenerateExcelRequest): Promise<Types.GetV1PurchaseAgreementsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseAgreementsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseAgreementsGenerateExcel: Api['getV1PurchaseAgreementsGenerateExcel'] = async (request: Types.GetV1PurchaseAgreementsGenerateExcelRequest): Promise<Types.GetV1PurchaseAgreementsGenerateExcelResponses> => {
  return await _getV1PurchaseAgreementsGenerateExcel(baseUrl, request)
}
const _postV1PurchaseAgreementsImport = async (url: string, request: Types.PostV1PurchaseAgreementsImportRequest): Promise<Types.PostV1PurchaseAgreementsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-agreements/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseAgreementsImport: Api['postV1PurchaseAgreementsImport'] = async (request: Types.PostV1PurchaseAgreementsImportRequest): Promise<Types.PostV1PurchaseAgreementsImportResponses> => {
  return await _postV1PurchaseAgreementsImport(baseUrl, request)
}
const _postV1Rfq = async (url: string, request: Types.PostV1RfqRequest): Promise<Types.PostV1RfqResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Rfq: Api['postV1Rfq'] = async (request: Types.PostV1RfqRequest): Promise<Types.PostV1RfqResponses> => {
  return await _postV1Rfq(baseUrl, request)
}
const _getV1Rfq = async (url: string, request: Types.GetV1RfqRequest): Promise<Types.GetV1RfqResponses> => {
  const queryParameters: (keyof Types.GetV1RfqRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Rfq: Api['getV1Rfq'] = async (request: Types.GetV1RfqRequest): Promise<Types.GetV1RfqResponses> => {
  return await _getV1Rfq(baseUrl, request)
}
const _postV1RfqSaveDraft = async (url: string, request: Types.PostV1RfqSaveDraftRequest): Promise<Types.PostV1RfqSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqSaveDraft: Api['postV1RfqSaveDraft'] = async (request: Types.PostV1RfqSaveDraftRequest): Promise<Types.PostV1RfqSaveDraftResponses> => {
  return await _postV1RfqSaveDraft(baseUrl, request)
}
const _getV1RfqResponseItems = async (url: string, request: Types.GetV1RfqResponseItemsRequest): Promise<Types.GetV1RfqResponseItemsResponses> => {
  const queryParameters: (keyof Types.GetV1RfqResponseItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/response-items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqResponseItems: Api['getV1RfqResponseItems'] = async (request: Types.GetV1RfqResponseItemsRequest): Promise<Types.GetV1RfqResponseItemsResponses> => {
  return await _getV1RfqResponseItems(baseUrl, request)
}
const _putV1RfqId = async (url: string, request: Types.PutV1RfqIdRequest): Promise<Types.PutV1RfqIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RfqId: Api['putV1RfqId'] = async (request: Types.PutV1RfqIdRequest): Promise<Types.PutV1RfqIdResponses> => {
  return await _putV1RfqId(baseUrl, request)
}
const _getV1RfqId = async (url: string, request: Types.GetV1RfqIdRequest): Promise<Types.GetV1RfqIdResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqId: Api['getV1RfqId'] = async (request: Types.GetV1RfqIdRequest): Promise<Types.GetV1RfqIdResponses> => {
  return await _getV1RfqId(baseUrl, request)
}
const _deleteV1RfqId = async (url: string, request: Types.DeleteV1RfqIdRequest): Promise<Types.DeleteV1RfqIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RfqId: Api['deleteV1RfqId'] = async (request: Types.DeleteV1RfqIdRequest): Promise<Types.DeleteV1RfqIdResponses> => {
  return await _deleteV1RfqId(baseUrl, request)
}
const _patchV1RfqIdStatus = async (url: string, request: Types.PatchV1RfqIdStatusRequest): Promise<Types.PatchV1RfqIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RfqIdStatus: Api['patchV1RfqIdStatus'] = async (request: Types.PatchV1RfqIdStatusRequest): Promise<Types.PatchV1RfqIdStatusResponses> => {
  return await _patchV1RfqIdStatus(baseUrl, request)
}
const _postV1RfqItems = async (url: string, request: Types.PostV1RfqItemsRequest): Promise<Types.PostV1RfqItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqItems: Api['postV1RfqItems'] = async (request: Types.PostV1RfqItemsRequest): Promise<Types.PostV1RfqItemsResponses> => {
  return await _postV1RfqItems(baseUrl, request)
}
const _getV1RfqItemsId = async (url: string, request: Types.GetV1RfqItemsIdRequest): Promise<Types.GetV1RfqItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RfqItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqItemsId: Api['getV1RfqItemsId'] = async (request: Types.GetV1RfqItemsIdRequest): Promise<Types.GetV1RfqItemsIdResponses> => {
  return await _getV1RfqItemsId(baseUrl, request)
}
const _putV1RfqItemsId = async (url: string, request: Types.PutV1RfqItemsIdRequest): Promise<Types.PutV1RfqItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RfqItemsId: Api['putV1RfqItemsId'] = async (request: Types.PutV1RfqItemsIdRequest): Promise<Types.PutV1RfqItemsIdResponses> => {
  return await _putV1RfqItemsId(baseUrl, request)
}
const _deleteV1RfqItemsId = async (url: string, request: Types.DeleteV1RfqItemsIdRequest): Promise<Types.DeleteV1RfqItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RfqItemsId: Api['deleteV1RfqItemsId'] = async (request: Types.DeleteV1RfqItemsIdRequest): Promise<Types.DeleteV1RfqItemsIdResponses> => {
  return await _deleteV1RfqItemsId(baseUrl, request)
}
const _postV1RfqTender = async (url: string, request: Types.PostV1RfqTenderRequest): Promise<Types.PostV1RfqTenderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/tender/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqTender: Api['postV1RfqTender'] = async (request: Types.PostV1RfqTenderRequest): Promise<Types.PostV1RfqTenderResponses> => {
  return await _postV1RfqTender(baseUrl, request)
}
const _deleteV1RfqTenderId = async (url: string, request: Types.DeleteV1RfqTenderIdRequest): Promise<Types.DeleteV1RfqTenderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/tender/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RfqTenderId: Api['deleteV1RfqTenderId'] = async (request: Types.DeleteV1RfqTenderIdRequest): Promise<Types.DeleteV1RfqTenderIdResponses> => {
  return await _deleteV1RfqTenderId(baseUrl, request)
}
const _postV1RfqIdResponse = async (url: string, request: Types.PostV1RfqIdResponseRequest): Promise<Types.PostV1RfqIdResponseResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqIdResponse: Api['postV1RfqIdResponse'] = async (request: Types.PostV1RfqIdResponseRequest): Promise<Types.PostV1RfqIdResponseResponses> => {
  return await _postV1RfqIdResponse(baseUrl, request)
}
const _getV1RfqIdResponse = async (url: string, request: Types.GetV1RfqIdResponseRequest): Promise<Types.GetV1RfqIdResponseResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdResponseRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdResponse: Api['getV1RfqIdResponse'] = async (request: Types.GetV1RfqIdResponseRequest): Promise<Types.GetV1RfqIdResponseResponses> => {
  return await _getV1RfqIdResponse(baseUrl, request)
}
const _postV1RfqIdResponseSaveDraft = async (url: string, request: Types.PostV1RfqIdResponseSaveDraftRequest): Promise<Types.PostV1RfqIdResponseSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqIdResponseSaveDraft: Api['postV1RfqIdResponseSaveDraft'] = async (request: Types.PostV1RfqIdResponseSaveDraftRequest): Promise<Types.PostV1RfqIdResponseSaveDraftResponses> => {
  return await _postV1RfqIdResponseSaveDraft(baseUrl, request)
}
const _putV1RfqIdResponseResponseId = async (url: string, request: Types.PutV1RfqIdResponseResponseIdRequest): Promise<Types.PutV1RfqIdResponseResponseIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RfqIdResponseResponseId: Api['putV1RfqIdResponseResponseId'] = async (request: Types.PutV1RfqIdResponseResponseIdRequest): Promise<Types.PutV1RfqIdResponseResponseIdResponses> => {
  return await _putV1RfqIdResponseResponseId(baseUrl, request)
}
const _getV1RfqIdResponseResponseId = async (url: string, request: Types.GetV1RfqIdResponseResponseIdRequest): Promise<Types.GetV1RfqIdResponseResponseIdResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdResponseResponseIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdResponseResponseId: Api['getV1RfqIdResponseResponseId'] = async (request: Types.GetV1RfqIdResponseResponseIdRequest): Promise<Types.GetV1RfqIdResponseResponseIdResponses> => {
  return await _getV1RfqIdResponseResponseId(baseUrl, request)
}
const _deleteV1RfqIdResponseResponseId = async (url: string, request: Types.DeleteV1RfqIdResponseResponseIdRequest): Promise<Types.DeleteV1RfqIdResponseResponseIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RfqIdResponseResponseId: Api['deleteV1RfqIdResponseResponseId'] = async (request: Types.DeleteV1RfqIdResponseResponseIdRequest): Promise<Types.DeleteV1RfqIdResponseResponseIdResponses> => {
  return await _deleteV1RfqIdResponseResponseId(baseUrl, request)
}
const _getV1RfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.GetV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.GetV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdResponseResponseIdItemsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdResponseResponseIdItemsItemId: Api['getV1RfqIdResponseResponseIdItemsItemId'] = async (request: Types.GetV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.GetV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _getV1RfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _putV1RfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.PutV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.PutV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RfqIdResponseResponseIdItemsItemId: Api['putV1RfqIdResponseResponseIdItemsItemId'] = async (request: Types.PutV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.PutV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _putV1RfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _deleteV1RfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.DeleteV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.DeleteV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RfqIdResponseResponseIdItemsItemId: Api['deleteV1RfqIdResponseResponseIdItemsItemId'] = async (request: Types.DeleteV1RfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.DeleteV1RfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _deleteV1RfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _postV1RfqIdAnalyze = async (url: string, request: Types.PostV1RfqIdAnalyzeRequest): Promise<Types.PostV1RfqIdAnalyzeResponses> => {
  const queryParameters: (keyof Types.PostV1RfqIdAnalyzeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/analyze?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqIdAnalyze: Api['postV1RfqIdAnalyze'] = async (request: Types.PostV1RfqIdAnalyzeRequest): Promise<Types.PostV1RfqIdAnalyzeResponses> => {
  return await _postV1RfqIdAnalyze(baseUrl, request)
}
const _postV1RfqIdAnalyzePreviousPrices = async (url: string, request: Types.PostV1RfqIdAnalyzePreviousPricesRequest): Promise<Types.PostV1RfqIdAnalyzePreviousPricesResponses> => {
  const queryParameters: (keyof Types.PostV1RfqIdAnalyzePreviousPricesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/analyze/previous-prices?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqIdAnalyzePreviousPrices: Api['postV1RfqIdAnalyzePreviousPrices'] = async (request: Types.PostV1RfqIdAnalyzePreviousPricesRequest): Promise<Types.PostV1RfqIdAnalyzePreviousPricesResponses> => {
  return await _postV1RfqIdAnalyzePreviousPrices(baseUrl, request)
}
const _postV1RfqIdAward = async (url: string, request: Types.PostV1RfqIdAwardRequest): Promise<Types.PostV1RfqIdAwardResponses> => {
  const queryParameters: (keyof Types.PostV1RfqIdAwardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/award?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqIdAward: Api['postV1RfqIdAward'] = async (request: Types.PostV1RfqIdAwardRequest): Promise<Types.PostV1RfqIdAwardResponses> => {
  return await _postV1RfqIdAward(baseUrl, request)
}
const _getV1RfqIdSendEmail = async (url: string, request: Types.GetV1RfqIdSendEmailRequest): Promise<Types.GetV1RfqIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdSendEmail: Api['getV1RfqIdSendEmail'] = async (request: Types.GetV1RfqIdSendEmailRequest): Promise<Types.GetV1RfqIdSendEmailResponses> => {
  return await _getV1RfqIdSendEmail(baseUrl, request)
}
const _getV1RfqIdDownload = async (url: string, request: Types.GetV1RfqIdDownloadRequest): Promise<Types.GetV1RfqIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdDownload: Api['getV1RfqIdDownload'] = async (request: Types.GetV1RfqIdDownloadRequest): Promise<Types.GetV1RfqIdDownloadResponses> => {
  return await _getV1RfqIdDownload(baseUrl, request)
}
const _getV1RfqIdProvidePoDetails = async (url: string, request: Types.GetV1RfqIdProvidePoDetailsRequest): Promise<Types.GetV1RfqIdProvidePoDetailsResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdProvidePoDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/provide-po-details?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdProvidePoDetails: Api['getV1RfqIdProvidePoDetails'] = async (request: Types.GetV1RfqIdProvidePoDetailsRequest): Promise<Types.GetV1RfqIdProvidePoDetailsResponses> => {
  return await _getV1RfqIdProvidePoDetails(baseUrl, request)
}
const _getV1RfqIdProvideAgreementDetails = async (url: string, request: Types.GetV1RfqIdProvideAgreementDetailsRequest): Promise<Types.GetV1RfqIdProvideAgreementDetailsResponses> => {
  const queryParameters: (keyof Types.GetV1RfqIdProvideAgreementDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/${request['id']}/provide-agreement-details?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqIdProvideAgreementDetails: Api['getV1RfqIdProvideAgreementDetails'] = async (request: Types.GetV1RfqIdProvideAgreementDetailsRequest): Promise<Types.GetV1RfqIdProvideAgreementDetailsResponses> => {
  return await _getV1RfqIdProvideAgreementDetails(baseUrl, request)
}
const _getV1RfqGenerateExcel = async (url: string, request: Types.GetV1RfqGenerateExcelRequest): Promise<Types.GetV1RfqGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RfqGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/rfq/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RfqGenerateExcel: Api['getV1RfqGenerateExcel'] = async (request: Types.GetV1RfqGenerateExcelRequest): Promise<Types.GetV1RfqGenerateExcelResponses> => {
  return await _getV1RfqGenerateExcel(baseUrl, request)
}
const _postV1RfqImport = async (url: string, request: Types.PostV1RfqImportRequest): Promise<Types.PostV1RfqImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rfq/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RfqImport: Api['postV1RfqImport'] = async (request: Types.PostV1RfqImportRequest): Promise<Types.PostV1RfqImportResponses> => {
  return await _postV1RfqImport(baseUrl, request)
}
const _postV1DeliveryOrders = async (url: string, request: Types.PostV1DeliveryOrdersRequest): Promise<Types.PostV1DeliveryOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrders: Api['postV1DeliveryOrders'] = async (request: Types.PostV1DeliveryOrdersRequest): Promise<Types.PostV1DeliveryOrdersResponses> => {
  return await _postV1DeliveryOrders(baseUrl, request)
}
const _getV1DeliveryOrders = async (url: string, request: Types.GetV1DeliveryOrdersRequest): Promise<Types.GetV1DeliveryOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrders: Api['getV1DeliveryOrders'] = async (request: Types.GetV1DeliveryOrdersRequest): Promise<Types.GetV1DeliveryOrdersResponses> => {
  return await _getV1DeliveryOrders(baseUrl, request)
}
const _postV1DeliveryOrdersSaveDraft = async (url: string, request: Types.PostV1DeliveryOrdersSaveDraftRequest): Promise<Types.PostV1DeliveryOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersSaveDraft: Api['postV1DeliveryOrdersSaveDraft'] = async (request: Types.PostV1DeliveryOrdersSaveDraftRequest): Promise<Types.PostV1DeliveryOrdersSaveDraftResponses> => {
  return await _postV1DeliveryOrdersSaveDraft(baseUrl, request)
}
const _getV1DeliveryOrdersId = async (url: string, request: Types.GetV1DeliveryOrdersIdRequest): Promise<Types.GetV1DeliveryOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersId: Api['getV1DeliveryOrdersId'] = async (request: Types.GetV1DeliveryOrdersIdRequest): Promise<Types.GetV1DeliveryOrdersIdResponses> => {
  return await _getV1DeliveryOrdersId(baseUrl, request)
}
const _deleteV1DeliveryOrdersId = async (url: string, request: Types.DeleteV1DeliveryOrdersIdRequest): Promise<Types.DeleteV1DeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersId: Api['deleteV1DeliveryOrdersId'] = async (request: Types.DeleteV1DeliveryOrdersIdRequest): Promise<Types.DeleteV1DeliveryOrdersIdResponses> => {
  return await _deleteV1DeliveryOrdersId(baseUrl, request)
}
const _putV1DeliveryOrdersId = async (url: string, request: Types.PutV1DeliveryOrdersIdRequest): Promise<Types.PutV1DeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersId: Api['putV1DeliveryOrdersId'] = async (request: Types.PutV1DeliveryOrdersIdRequest): Promise<Types.PutV1DeliveryOrdersIdResponses> => {
  return await _putV1DeliveryOrdersId(baseUrl, request)
}
const _patchV1DeliveryOrdersStatusId = async (url: string, request: Types.PatchV1DeliveryOrdersStatusIdRequest): Promise<Types.PatchV1DeliveryOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DeliveryOrdersStatusId: Api['patchV1DeliveryOrdersStatusId'] = async (request: Types.PatchV1DeliveryOrdersStatusIdRequest): Promise<Types.PatchV1DeliveryOrdersStatusIdResponses> => {
  return await _patchV1DeliveryOrdersStatusId(baseUrl, request)
}
const _getV1DeliveryOrdersItemsId = async (url: string, request: Types.GetV1DeliveryOrdersItemsIdRequest): Promise<Types.GetV1DeliveryOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersItemsId: Api['getV1DeliveryOrdersItemsId'] = async (request: Types.GetV1DeliveryOrdersItemsIdRequest): Promise<Types.GetV1DeliveryOrdersItemsIdResponses> => {
  return await _getV1DeliveryOrdersItemsId(baseUrl, request)
}
const _putV1DeliveryOrdersItemsId = async (url: string, request: Types.PutV1DeliveryOrdersItemsIdRequest): Promise<Types.PutV1DeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersItemsId: Api['putV1DeliveryOrdersItemsId'] = async (request: Types.PutV1DeliveryOrdersItemsIdRequest): Promise<Types.PutV1DeliveryOrdersItemsIdResponses> => {
  return await _putV1DeliveryOrdersItemsId(baseUrl, request)
}
const _deleteV1DeliveryOrdersItemsId = async (url: string, request: Types.DeleteV1DeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersItemsId: Api['deleteV1DeliveryOrdersItemsId'] = async (request: Types.DeleteV1DeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersItemsIdResponses> => {
  return await _deleteV1DeliveryOrdersItemsId(baseUrl, request)
}
const _postV1DeliveryOrdersPackages = async (url: string, request: Types.PostV1DeliveryOrdersPackagesRequest): Promise<Types.PostV1DeliveryOrdersPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1DeliveryOrdersPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersPackages: Api['postV1DeliveryOrdersPackages'] = async (request: Types.PostV1DeliveryOrdersPackagesRequest): Promise<Types.PostV1DeliveryOrdersPackagesResponses> => {
  return await _postV1DeliveryOrdersPackages(baseUrl, request)
}
const _getV1DeliveryOrdersPackagesId = async (url: string, request: Types.GetV1DeliveryOrdersPackagesIdRequest): Promise<Types.GetV1DeliveryOrdersPackagesIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersPackagesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersPackagesId: Api['getV1DeliveryOrdersPackagesId'] = async (request: Types.GetV1DeliveryOrdersPackagesIdRequest): Promise<Types.GetV1DeliveryOrdersPackagesIdResponses> => {
  return await _getV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _putV1DeliveryOrdersPackagesId = async (url: string, request: Types.PutV1DeliveryOrdersPackagesIdRequest): Promise<Types.PutV1DeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersPackagesId: Api['putV1DeliveryOrdersPackagesId'] = async (request: Types.PutV1DeliveryOrdersPackagesIdRequest): Promise<Types.PutV1DeliveryOrdersPackagesIdResponses> => {
  return await _putV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _deleteV1DeliveryOrdersPackagesId = async (url: string, request: Types.DeleteV1DeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersPackagesId: Api['deleteV1DeliveryOrdersPackagesId'] = async (request: Types.DeleteV1DeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersPackagesIdResponses> => {
  return await _deleteV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _getV1DeliveryOrdersIdPackages = async (url: string, request: Types.GetV1DeliveryOrdersIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersIdPackagesResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/packages/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdPackages: Api['getV1DeliveryOrdersIdPackages'] = async (request: Types.GetV1DeliveryOrdersIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersIdPackagesResponses> => {
  return await _getV1DeliveryOrdersIdPackages(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdPackages: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersDeliveryIdItemsItemIdPackages: Api['getV1DeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId = async (url: string, request: Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId: Api['deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId'] = async (request: Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  return await _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdTracking: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdTracking'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment(baseUrl, request)
}
const _getV1DeliveryOrdersIdSendEmail = async (url: string, request: Types.GetV1DeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1DeliveryOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdSendEmail: Api['getV1DeliveryOrdersIdSendEmail'] = async (request: Types.GetV1DeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1DeliveryOrdersIdSendEmailResponses> => {
  return await _getV1DeliveryOrdersIdSendEmail(baseUrl, request)
}
const _getV1DeliveryOrdersIdDownload = async (url: string, request: Types.GetV1DeliveryOrdersIdDownloadRequest): Promise<Types.GetV1DeliveryOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdDownload: Api['getV1DeliveryOrdersIdDownload'] = async (request: Types.GetV1DeliveryOrdersIdDownloadRequest): Promise<Types.GetV1DeliveryOrdersIdDownloadResponses> => {
  return await _getV1DeliveryOrdersIdDownload(baseUrl, request)
}
const _getV1DeliveryOrdersGenerateExcel = async (url: string, request: Types.GetV1DeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1DeliveryOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/delivery-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersGenerateExcel: Api['getV1DeliveryOrdersGenerateExcel'] = async (request: Types.GetV1DeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1DeliveryOrdersGenerateExcelResponses> => {
  return await _getV1DeliveryOrdersGenerateExcel(baseUrl, request)
}
const _postV1Vra = async (url: string, request: Types.PostV1VraRequest): Promise<Types.PostV1VraResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Vra: Api['postV1Vra'] = async (request: Types.PostV1VraRequest): Promise<Types.PostV1VraResponses> => {
  return await _postV1Vra(baseUrl, request)
}
const _getV1Vra = async (url: string, request: Types.GetV1VraRequest): Promise<Types.GetV1VraResponses> => {
  const queryParameters: (keyof Types.GetV1VraRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Vra: Api['getV1Vra'] = async (request: Types.GetV1VraRequest): Promise<Types.GetV1VraResponses> => {
  return await _getV1Vra(baseUrl, request)
}
const _postV1VraSaveDraft = async (url: string, request: Types.PostV1VraSaveDraftRequest): Promise<Types.PostV1VraSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1VraSaveDraft: Api['postV1VraSaveDraft'] = async (request: Types.PostV1VraSaveDraftRequest): Promise<Types.PostV1VraSaveDraftResponses> => {
  return await _postV1VraSaveDraft(baseUrl, request)
}
const _getV1VraId = async (url: string, request: Types.GetV1VraIdRequest): Promise<Types.GetV1VraIdResponses> => {
  const queryParameters: (keyof Types.GetV1VraIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraId: Api['getV1VraId'] = async (request: Types.GetV1VraIdRequest): Promise<Types.GetV1VraIdResponses> => {
  return await _getV1VraId(baseUrl, request)
}
const _deleteV1VraId = async (url: string, request: Types.DeleteV1VraIdRequest): Promise<Types.DeleteV1VraIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1VraId: Api['deleteV1VraId'] = async (request: Types.DeleteV1VraIdRequest): Promise<Types.DeleteV1VraIdResponses> => {
  return await _deleteV1VraId(baseUrl, request)
}
const _putV1VraId = async (url: string, request: Types.PutV1VraIdRequest): Promise<Types.PutV1VraIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1VraId: Api['putV1VraId'] = async (request: Types.PutV1VraIdRequest): Promise<Types.PutV1VraIdResponses> => {
  return await _putV1VraId(baseUrl, request)
}
const _patchV1VraStatusId = async (url: string, request: Types.PatchV1VraStatusIdRequest): Promise<Types.PatchV1VraStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1VraStatusId: Api['patchV1VraStatusId'] = async (request: Types.PatchV1VraStatusIdRequest): Promise<Types.PatchV1VraStatusIdResponses> => {
  return await _patchV1VraStatusId(baseUrl, request)
}
const _postV1VraAddApprover = async (url: string, request: Types.PostV1VraAddApproverRequest): Promise<Types.PostV1VraAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1VraAddApprover: Api['postV1VraAddApprover'] = async (request: Types.PostV1VraAddApproverRequest): Promise<Types.PostV1VraAddApproverResponses> => {
  return await _postV1VraAddApprover(baseUrl, request)
}
const _putV1VraApprovalStatusId = async (url: string, request: Types.PutV1VraApprovalStatusIdRequest): Promise<Types.PutV1VraApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1VraApprovalStatusId: Api['putV1VraApprovalStatusId'] = async (request: Types.PutV1VraApprovalStatusIdRequest): Promise<Types.PutV1VraApprovalStatusIdResponses> => {
  return await _putV1VraApprovalStatusId(baseUrl, request)
}
const _getV1VraItemsId = async (url: string, request: Types.GetV1VraItemsIdRequest): Promise<Types.GetV1VraItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1VraItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraItemsId: Api['getV1VraItemsId'] = async (request: Types.GetV1VraItemsIdRequest): Promise<Types.GetV1VraItemsIdResponses> => {
  return await _getV1VraItemsId(baseUrl, request)
}
const _putV1VraItemsId = async (url: string, request: Types.PutV1VraItemsIdRequest): Promise<Types.PutV1VraItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1VraItemsId: Api['putV1VraItemsId'] = async (request: Types.PutV1VraItemsIdRequest): Promise<Types.PutV1VraItemsIdResponses> => {
  return await _putV1VraItemsId(baseUrl, request)
}
const _deleteV1VraItemsId = async (url: string, request: Types.DeleteV1VraItemsIdRequest): Promise<Types.DeleteV1VraItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1VraItemsId: Api['deleteV1VraItemsId'] = async (request: Types.DeleteV1VraItemsIdRequest): Promise<Types.DeleteV1VraItemsIdResponses> => {
  return await _deleteV1VraItemsId(baseUrl, request)
}
const _postV1VraItems = async (url: string, request: Types.PostV1VraItemsRequest): Promise<Types.PostV1VraItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1VraItems: Api['postV1VraItems'] = async (request: Types.PostV1VraItemsRequest): Promise<Types.PostV1VraItemsResponses> => {
  return await _postV1VraItems(baseUrl, request)
}
const _getV1VraIdCreateDebitNote = async (url: string, request: Types.GetV1VraIdCreateDebitNoteRequest): Promise<Types.GetV1VraIdCreateDebitNoteResponses> => {
  const queryParameters: (keyof Types.GetV1VraIdCreateDebitNoteRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}/create-debit-note?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraIdCreateDebitNote: Api['getV1VraIdCreateDebitNote'] = async (request: Types.GetV1VraIdCreateDebitNoteRequest): Promise<Types.GetV1VraIdCreateDebitNoteResponses> => {
  return await _getV1VraIdCreateDebitNote(baseUrl, request)
}
const _getV1VraIdSendEmail = async (url: string, request: Types.GetV1VraIdSendEmailRequest): Promise<Types.GetV1VraIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1VraIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraIdSendEmail: Api['getV1VraIdSendEmail'] = async (request: Types.GetV1VraIdSendEmailRequest): Promise<Types.GetV1VraIdSendEmailResponses> => {
  return await _getV1VraIdSendEmail(baseUrl, request)
}
const _getV1VraIdDownload = async (url: string, request: Types.GetV1VraIdDownloadRequest): Promise<Types.GetV1VraIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1VraIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraIdDownload: Api['getV1VraIdDownload'] = async (request: Types.GetV1VraIdDownloadRequest): Promise<Types.GetV1VraIdDownloadResponses> => {
  return await _getV1VraIdDownload(baseUrl, request)
}
const _getV1VraGenerateExcel = async (url: string, request: Types.GetV1VraGenerateExcelRequest): Promise<Types.GetV1VraGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1VraGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/vra/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1VraGenerateExcel: Api['getV1VraGenerateExcel'] = async (request: Types.GetV1VraGenerateExcelRequest): Promise<Types.GetV1VraGenerateExcelResponses> => {
  return await _getV1VraGenerateExcel(baseUrl, request)
}
const _postV1VraImport = async (url: string, request: Types.PostV1VraImportRequest): Promise<Types.PostV1VraImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/vra/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1VraImport: Api['postV1VraImport'] = async (request: Types.PostV1VraImportRequest): Promise<Types.PostV1VraImportResponses> => {
  return await _postV1VraImport(baseUrl, request)
}
const _postV1PurchaseOrders = async (url: string, request: Types.PostV1PurchaseOrdersRequest): Promise<Types.PostV1PurchaseOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrders: Api['postV1PurchaseOrders'] = async (request: Types.PostV1PurchaseOrdersRequest): Promise<Types.PostV1PurchaseOrdersResponses> => {
  return await _postV1PurchaseOrders(baseUrl, request)
}
const _getV1PurchaseOrders = async (url: string, request: Types.GetV1PurchaseOrdersRequest): Promise<Types.GetV1PurchaseOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrders: Api['getV1PurchaseOrders'] = async (request: Types.GetV1PurchaseOrdersRequest): Promise<Types.GetV1PurchaseOrdersResponses> => {
  return await _getV1PurchaseOrders(baseUrl, request)
}
const _postV1PurchaseOrdersSaveDraft = async (url: string, request: Types.PostV1PurchaseOrdersSaveDraftRequest): Promise<Types.PostV1PurchaseOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersSaveDraft: Api['postV1PurchaseOrdersSaveDraft'] = async (request: Types.PostV1PurchaseOrdersSaveDraftRequest): Promise<Types.PostV1PurchaseOrdersSaveDraftResponses> => {
  return await _postV1PurchaseOrdersSaveDraft(baseUrl, request)
}
const _getV1PurchaseOrdersId = async (url: string, request: Types.GetV1PurchaseOrdersIdRequest): Promise<Types.GetV1PurchaseOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersId: Api['getV1PurchaseOrdersId'] = async (request: Types.GetV1PurchaseOrdersIdRequest): Promise<Types.GetV1PurchaseOrdersIdResponses> => {
  return await _getV1PurchaseOrdersId(baseUrl, request)
}
const _putV1PurchaseOrdersId = async (url: string, request: Types.PutV1PurchaseOrdersIdRequest): Promise<Types.PutV1PurchaseOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersId: Api['putV1PurchaseOrdersId'] = async (request: Types.PutV1PurchaseOrdersIdRequest): Promise<Types.PutV1PurchaseOrdersIdResponses> => {
  return await _putV1PurchaseOrdersId(baseUrl, request)
}
const _deleteV1PurchaseOrdersId = async (url: string, request: Types.DeleteV1PurchaseOrdersIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseOrdersId: Api['deleteV1PurchaseOrdersId'] = async (request: Types.DeleteV1PurchaseOrdersIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdResponses> => {
  return await _deleteV1PurchaseOrdersId(baseUrl, request)
}
const _patchV1PurchaseOrdersIdStatus = async (url: string, request: Types.PatchV1PurchaseOrdersIdStatusRequest): Promise<Types.PatchV1PurchaseOrdersIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1PurchaseOrdersIdStatus: Api['patchV1PurchaseOrdersIdStatus'] = async (request: Types.PatchV1PurchaseOrdersIdStatusRequest): Promise<Types.PatchV1PurchaseOrdersIdStatusResponses> => {
  return await _patchV1PurchaseOrdersIdStatus(baseUrl, request)
}
const _postV1PurchaseOrdersAddApprover = async (url: string, request: Types.PostV1PurchaseOrdersAddApproverRequest): Promise<Types.PostV1PurchaseOrdersAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersAddApprover: Api['postV1PurchaseOrdersAddApprover'] = async (request: Types.PostV1PurchaseOrdersAddApproverRequest): Promise<Types.PostV1PurchaseOrdersAddApproverResponses> => {
  return await _postV1PurchaseOrdersAddApprover(baseUrl, request)
}
const _putV1PurchaseOrdersApprovalStatusId = async (url: string, request: Types.PutV1PurchaseOrdersApprovalStatusIdRequest): Promise<Types.PutV1PurchaseOrdersApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersApprovalStatusId: Api['putV1PurchaseOrdersApprovalStatusId'] = async (request: Types.PutV1PurchaseOrdersApprovalStatusIdRequest): Promise<Types.PutV1PurchaseOrdersApprovalStatusIdResponses> => {
  return await _putV1PurchaseOrdersApprovalStatusId(baseUrl, request)
}
const _postV1PurchaseOrdersItems = async (url: string, request: Types.PostV1PurchaseOrdersItemsRequest): Promise<Types.PostV1PurchaseOrdersItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersItems: Api['postV1PurchaseOrdersItems'] = async (request: Types.PostV1PurchaseOrdersItemsRequest): Promise<Types.PostV1PurchaseOrdersItemsResponses> => {
  return await _postV1PurchaseOrdersItems(baseUrl, request)
}
const _getV1PurchaseOrdersItemsId = async (url: string, request: Types.GetV1PurchaseOrdersItemsIdRequest): Promise<Types.GetV1PurchaseOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersItemsId: Api['getV1PurchaseOrdersItemsId'] = async (request: Types.GetV1PurchaseOrdersItemsIdRequest): Promise<Types.GetV1PurchaseOrdersItemsIdResponses> => {
  return await _getV1PurchaseOrdersItemsId(baseUrl, request)
}
const _putV1PurchaseOrdersItemsId = async (url: string, request: Types.PutV1PurchaseOrdersItemsIdRequest): Promise<Types.PutV1PurchaseOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersItemsId: Api['putV1PurchaseOrdersItemsId'] = async (request: Types.PutV1PurchaseOrdersItemsIdRequest): Promise<Types.PutV1PurchaseOrdersItemsIdResponses> => {
  return await _putV1PurchaseOrdersItemsId(baseUrl, request)
}
const _deleteV1PurchaseOrdersItemsId = async (url: string, request: Types.DeleteV1PurchaseOrdersItemsIdRequest): Promise<Types.DeleteV1PurchaseOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseOrdersItemsId: Api['deleteV1PurchaseOrdersItemsId'] = async (request: Types.DeleteV1PurchaseOrdersItemsIdRequest): Promise<Types.DeleteV1PurchaseOrdersItemsIdResponses> => {
  return await _deleteV1PurchaseOrdersItemsId(baseUrl, request)
}
const _postV1PurchaseOrdersExpenses = async (url: string, request: Types.PostV1PurchaseOrdersExpensesRequest): Promise<Types.PostV1PurchaseOrdersExpensesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/expenses/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersExpenses: Api['postV1PurchaseOrdersExpenses'] = async (request: Types.PostV1PurchaseOrdersExpensesRequest): Promise<Types.PostV1PurchaseOrdersExpensesResponses> => {
  return await _postV1PurchaseOrdersExpenses(baseUrl, request)
}
const _getV1PurchaseOrdersExpensesId = async (url: string, request: Types.GetV1PurchaseOrdersExpensesIdRequest): Promise<Types.GetV1PurchaseOrdersExpensesIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersExpensesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/expenses/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersExpensesId: Api['getV1PurchaseOrdersExpensesId'] = async (request: Types.GetV1PurchaseOrdersExpensesIdRequest): Promise<Types.GetV1PurchaseOrdersExpensesIdResponses> => {
  return await _getV1PurchaseOrdersExpensesId(baseUrl, request)
}
const _putV1PurchaseOrdersExpensesId = async (url: string, request: Types.PutV1PurchaseOrdersExpensesIdRequest): Promise<Types.PutV1PurchaseOrdersExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/expenses/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersExpensesId: Api['putV1PurchaseOrdersExpensesId'] = async (request: Types.PutV1PurchaseOrdersExpensesIdRequest): Promise<Types.PutV1PurchaseOrdersExpensesIdResponses> => {
  return await _putV1PurchaseOrdersExpensesId(baseUrl, request)
}
const _deleteV1PurchaseOrdersExpensesId = async (url: string, request: Types.DeleteV1PurchaseOrdersExpensesIdRequest): Promise<Types.DeleteV1PurchaseOrdersExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/expenses/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseOrdersExpensesId: Api['deleteV1PurchaseOrdersExpensesId'] = async (request: Types.DeleteV1PurchaseOrdersExpensesIdRequest): Promise<Types.DeleteV1PurchaseOrdersExpensesIdResponses> => {
  return await _deleteV1PurchaseOrdersExpensesId(baseUrl, request)
}
const _postV1PurchaseOrdersIdGrn = async (url: string, request: Types.PostV1PurchaseOrdersIdGrnRequest): Promise<Types.PostV1PurchaseOrdersIdGrnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersIdGrn: Api['postV1PurchaseOrdersIdGrn'] = async (request: Types.PostV1PurchaseOrdersIdGrnRequest): Promise<Types.PostV1PurchaseOrdersIdGrnResponses> => {
  return await _postV1PurchaseOrdersIdGrn(baseUrl, request)
}
const _getV1PurchaseOrdersIdGrn = async (url: string, request: Types.GetV1PurchaseOrdersIdGrnRequest): Promise<Types.GetV1PurchaseOrdersIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdGrn: Api['getV1PurchaseOrdersIdGrn'] = async (request: Types.GetV1PurchaseOrdersIdGrnRequest): Promise<Types.GetV1PurchaseOrdersIdGrnResponses> => {
  return await _getV1PurchaseOrdersIdGrn(baseUrl, request)
}
const _putV1PurchaseOrdersIdGrnGrnId = async (url: string, request: Types.PutV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.PutV1PurchaseOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersIdGrnGrnId: Api['putV1PurchaseOrdersIdGrnGrnId'] = async (request: Types.PutV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.PutV1PurchaseOrdersIdGrnGrnIdResponses> => {
  return await _putV1PurchaseOrdersIdGrnGrnId(baseUrl, request)
}
const _getV1PurchaseOrdersIdGrnGrnId = async (url: string, request: Types.GetV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdGrnGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdGrnGrnId: Api['getV1PurchaseOrdersIdGrnGrnId'] = async (request: Types.GetV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdResponses> => {
  return await _getV1PurchaseOrdersIdGrnGrnId(baseUrl, request)
}
const _deleteV1PurchaseOrdersIdGrnGrnId = async (url: string, request: Types.DeleteV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseOrdersIdGrnGrnId: Api['deleteV1PurchaseOrdersIdGrnGrnId'] = async (request: Types.DeleteV1PurchaseOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdGrnGrnIdResponses> => {
  return await _deleteV1PurchaseOrdersIdGrnGrnId(baseUrl, request)
}
const _getV1PurchaseOrdersIdGrnGrnIdDownload = async (url: string, request: Types.GetV1PurchaseOrdersIdGrnGrnIdDownloadRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdGrnGrnIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdGrnGrnIdDownload: Api['getV1PurchaseOrdersIdGrnGrnIdDownload'] = async (request: Types.GetV1PurchaseOrdersIdGrnGrnIdDownloadRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdDownloadResponses> => {
  return await _getV1PurchaseOrdersIdGrnGrnIdDownload(baseUrl, request)
}
const _getV1PurchaseOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.GetV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdGrnGrnIdItemItemId: Api['getV1PurchaseOrdersIdGrnGrnIdItemItemId'] = async (request: Types.GetV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.GetV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _getV1PurchaseOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _putV1PurchaseOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.PutV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.PutV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseOrdersIdGrnGrnIdItemItemId: Api['putV1PurchaseOrdersIdGrnGrnIdItemItemId'] = async (request: Types.PutV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.PutV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _putV1PurchaseOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _deleteV1PurchaseOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.DeleteV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseOrdersIdGrnGrnIdItemItemId: Api['deleteV1PurchaseOrdersIdGrnGrnIdItemItemId'] = async (request: Types.DeleteV1PurchaseOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.DeleteV1PurchaseOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _deleteV1PurchaseOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking = async (url: string, request: Types.PostV1PurchaseOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1PurchaseOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking: Api['postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking'] = async (request: Types.PostV1PurchaseOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1PurchaseOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  return await _postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking(baseUrl, request)
}
const _postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment = async (url: string, request: Types.PostV1PurchaseOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1PurchaseOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/grn/${request['grnId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment: Api['postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment'] = async (request: Types.PostV1PurchaseOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1PurchaseOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  return await _postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment(baseUrl, request)
}
const _getV1PurchaseOrdersIdCreateBill = async (url: string, request: Types.GetV1PurchaseOrdersIdCreateBillRequest): Promise<Types.GetV1PurchaseOrdersIdCreateBillResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdCreateBillRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/create-bill?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdCreateBill: Api['getV1PurchaseOrdersIdCreateBill'] = async (request: Types.GetV1PurchaseOrdersIdCreateBillRequest): Promise<Types.GetV1PurchaseOrdersIdCreateBillResponses> => {
  return await _getV1PurchaseOrdersIdCreateBill(baseUrl, request)
}
const _getV1PurchaseOrdersReceipts = async (url: string, request: Types.GetV1PurchaseOrdersReceiptsRequest): Promise<Types.GetV1PurchaseOrdersReceiptsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersReceiptsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/receipts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersReceipts: Api['getV1PurchaseOrdersReceipts'] = async (request: Types.GetV1PurchaseOrdersReceiptsRequest): Promise<Types.GetV1PurchaseOrdersReceiptsResponses> => {
  return await _getV1PurchaseOrdersReceipts(baseUrl, request)
}
const _getV1PurchaseOrdersIdSendEmail = async (url: string, request: Types.GetV1PurchaseOrdersIdSendEmailRequest): Promise<Types.GetV1PurchaseOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdSendEmail: Api['getV1PurchaseOrdersIdSendEmail'] = async (request: Types.GetV1PurchaseOrdersIdSendEmailRequest): Promise<Types.GetV1PurchaseOrdersIdSendEmailResponses> => {
  return await _getV1PurchaseOrdersIdSendEmail(baseUrl, request)
}
const _getV1PurchaseOrdersIdDownload = async (url: string, request: Types.GetV1PurchaseOrdersIdDownloadRequest): Promise<Types.GetV1PurchaseOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersIdDownload: Api['getV1PurchaseOrdersIdDownload'] = async (request: Types.GetV1PurchaseOrdersIdDownloadRequest): Promise<Types.GetV1PurchaseOrdersIdDownloadResponses> => {
  return await _getV1PurchaseOrdersIdDownload(baseUrl, request)
}
const _getV1PurchaseOrdersOrderIdGrnIdScrap = async (url: string, request: Types.GetV1PurchaseOrdersOrderIdGrnIdScrapRequest): Promise<Types.GetV1PurchaseOrdersOrderIdGrnIdScrapResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersOrderIdGrnIdScrapRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/${request['orderId']}/grn/${request['id']}/scrap?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersOrderIdGrnIdScrap: Api['getV1PurchaseOrdersOrderIdGrnIdScrap'] = async (request: Types.GetV1PurchaseOrdersOrderIdGrnIdScrapRequest): Promise<Types.GetV1PurchaseOrdersOrderIdGrnIdScrapResponses> => {
  return await _getV1PurchaseOrdersOrderIdGrnIdScrap(baseUrl, request)
}
const _getV1PurchaseOrdersGenerateExcel = async (url: string, request: Types.GetV1PurchaseOrdersGenerateExcelRequest): Promise<Types.GetV1PurchaseOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/purchase-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseOrdersGenerateExcel: Api['getV1PurchaseOrdersGenerateExcel'] = async (request: Types.GetV1PurchaseOrdersGenerateExcelRequest): Promise<Types.GetV1PurchaseOrdersGenerateExcelResponses> => {
  return await _getV1PurchaseOrdersGenerateExcel(baseUrl, request)
}
const _postV1PurchaseOrdersImport = async (url: string, request: Types.PostV1PurchaseOrdersImportRequest): Promise<Types.PostV1PurchaseOrdersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-orders/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseOrdersImport: Api['postV1PurchaseOrdersImport'] = async (request: Types.PostV1PurchaseOrdersImportRequest): Promise<Types.PostV1PurchaseOrdersImportResponses> => {
  return await _postV1PurchaseOrdersImport(baseUrl, request)
}
const _postV1LandingCost = async (url: string, request: Types.PostV1LandingCostRequest): Promise<Types.PostV1LandingCostResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LandingCost: Api['postV1LandingCost'] = async (request: Types.PostV1LandingCostRequest): Promise<Types.PostV1LandingCostResponses> => {
  return await _postV1LandingCost(baseUrl, request)
}
const _getV1LandingCost = async (url: string, request: Types.GetV1LandingCostRequest): Promise<Types.GetV1LandingCostResponses> => {
  const queryParameters: (keyof Types.GetV1LandingCostRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LandingCost: Api['getV1LandingCost'] = async (request: Types.GetV1LandingCostRequest): Promise<Types.GetV1LandingCostResponses> => {
  return await _getV1LandingCost(baseUrl, request)
}
const _postV1LandingCostCompute = async (url: string, request: Types.PostV1LandingCostComputeRequest): Promise<Types.PostV1LandingCostComputeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/compute`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LandingCostCompute: Api['postV1LandingCostCompute'] = async (request: Types.PostV1LandingCostComputeRequest): Promise<Types.PostV1LandingCostComputeResponses> => {
  return await _postV1LandingCostCompute(baseUrl, request)
}
const _getV1LandingCostId = async (url: string, request: Types.GetV1LandingCostIdRequest): Promise<Types.GetV1LandingCostIdResponses> => {
  const queryParameters: (keyof Types.GetV1LandingCostIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LandingCostId: Api['getV1LandingCostId'] = async (request: Types.GetV1LandingCostIdRequest): Promise<Types.GetV1LandingCostIdResponses> => {
  return await _getV1LandingCostId(baseUrl, request)
}
const _putV1LandingCostId = async (url: string, request: Types.PutV1LandingCostIdRequest): Promise<Types.PutV1LandingCostIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LandingCostId: Api['putV1LandingCostId'] = async (request: Types.PutV1LandingCostIdRequest): Promise<Types.PutV1LandingCostIdResponses> => {
  return await _putV1LandingCostId(baseUrl, request)
}
const _deleteV1LandingCostId = async (url: string, request: Types.DeleteV1LandingCostIdRequest): Promise<Types.DeleteV1LandingCostIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LandingCostId: Api['deleteV1LandingCostId'] = async (request: Types.DeleteV1LandingCostIdRequest): Promise<Types.DeleteV1LandingCostIdResponses> => {
  return await _deleteV1LandingCostId(baseUrl, request)
}
const _postV1LandingCostItems = async (url: string, request: Types.PostV1LandingCostItemsRequest): Promise<Types.PostV1LandingCostItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LandingCostItems: Api['postV1LandingCostItems'] = async (request: Types.PostV1LandingCostItemsRequest): Promise<Types.PostV1LandingCostItemsResponses> => {
  return await _postV1LandingCostItems(baseUrl, request)
}
const _getV1LandingCostItemsId = async (url: string, request: Types.GetV1LandingCostItemsIdRequest): Promise<Types.GetV1LandingCostItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1LandingCostItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LandingCostItemsId: Api['getV1LandingCostItemsId'] = async (request: Types.GetV1LandingCostItemsIdRequest): Promise<Types.GetV1LandingCostItemsIdResponses> => {
  return await _getV1LandingCostItemsId(baseUrl, request)
}
const _putV1LandingCostItemsId = async (url: string, request: Types.PutV1LandingCostItemsIdRequest): Promise<Types.PutV1LandingCostItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LandingCostItemsId: Api['putV1LandingCostItemsId'] = async (request: Types.PutV1LandingCostItemsIdRequest): Promise<Types.PutV1LandingCostItemsIdResponses> => {
  return await _putV1LandingCostItemsId(baseUrl, request)
}
const _deleteV1LandingCostItemsId = async (url: string, request: Types.DeleteV1LandingCostItemsIdRequest): Promise<Types.DeleteV1LandingCostItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LandingCostItemsId: Api['deleteV1LandingCostItemsId'] = async (request: Types.DeleteV1LandingCostItemsIdRequest): Promise<Types.DeleteV1LandingCostItemsIdResponses> => {
  return await _deleteV1LandingCostItemsId(baseUrl, request)
}
const _postV1LandingCostValidate = async (url: string, request: Types.PostV1LandingCostValidateRequest): Promise<Types.PostV1LandingCostValidateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/validate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LandingCostValidate: Api['postV1LandingCostValidate'] = async (request: Types.PostV1LandingCostValidateRequest): Promise<Types.PostV1LandingCostValidateResponses> => {
  return await _postV1LandingCostValidate(baseUrl, request)
}
const _getV1LandingCostGenerateExcel = async (url: string, request: Types.GetV1LandingCostGenerateExcelRequest): Promise<Types.GetV1LandingCostGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1LandingCostGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/landing-cost/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LandingCostGenerateExcel: Api['getV1LandingCostGenerateExcel'] = async (request: Types.GetV1LandingCostGenerateExcelRequest): Promise<Types.GetV1LandingCostGenerateExcelResponses> => {
  return await _getV1LandingCostGenerateExcel(baseUrl, request)
}
const _postV1LandingCostImport = async (url: string, request: Types.PostV1LandingCostImportRequest): Promise<Types.PostV1LandingCostImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/landing-cost/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LandingCostImport: Api['postV1LandingCostImport'] = async (request: Types.PostV1LandingCostImportRequest): Promise<Types.PostV1LandingCostImportResponses> => {
  return await _postV1LandingCostImport(baseUrl, request)
}
const _postV1PurchaseTermsAndConditions = async (url: string, request: Types.PostV1PurchaseTermsAndConditionsRequest): Promise<Types.PostV1PurchaseTermsAndConditionsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }
  const response = await fetch(`${url}/v1/purchase-terms-and-conditions/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })
  if (!response.ok) {
    throw new Error(await response.text())
  }
  return await response.json()
}
export const postV1PurchaseTermsAndConditions: Api['postV1PurchaseTermsAndConditions'] = async (request: Types.PostV1PurchaseTermsAndConditionsRequest): Promise<Types.PostV1PurchaseTermsAndConditionsResponses> => {
  return await _postV1PurchaseTermsAndConditions(baseUrl, request)
}
const _getV1PurchaseTermsAndConditions = async (url: string, request: Types.GetV1PurchaseTermsAndConditionsRequest): Promise<Types.GetV1PurchaseTermsAndConditionsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseTermsAndConditionsRequest)[] = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => { searchParams.append(qp, p) })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }
  const response = await fetch(`${url}/v1/purchase-terms-and-conditions/?${searchParams.toString()}`, {
    headers
  })
  if (!response.ok) {
    throw new Error(await response.text())
  }
  return await response.json()
}
export const getV1PurchaseTermsAndConditions: Api['getV1PurchaseTermsAndConditions'] = async (request: Types.GetV1PurchaseTermsAndConditionsRequest): Promise<Types.GetV1PurchaseTermsAndConditionsResponses> => {
  return await _getV1PurchaseTermsAndConditions(baseUrl, request)
}
const _getV1PurchaseTermsAndConditionsId = async (url: string, request: Types.GetV1PurchaseTermsAndConditionsIdRequest): Promise<Types.GetV1PurchaseTermsAndConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }
  const response = await fetch(`${url}/v1/purchase-terms-and-conditions/${request['id']}`, {
    headers
  })
  if (!response.ok) {
    throw new Error(await response.text())
  }
  return await response.json()
}
export const getV1PurchaseTermsAndConditionsId: Api['getV1PurchaseTermsAndConditionsId'] = async (request: Types.GetV1PurchaseTermsAndConditionsIdRequest): Promise<Types.GetV1PurchaseTermsAndConditionsIdResponses> => {
  return await _getV1PurchaseTermsAndConditionsId(baseUrl, request)
}
const _putV1PurchaseTermsAndConditionsId = async (url: string, request: Types.PutV1PurchaseTermsAndConditionsIdRequest): Promise<Types.PutV1PurchaseTermsAndConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }
  const response = await fetch(`${url}/v1/purchase-terms-and-conditions/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })
  if (!response.ok) {
    throw new Error(await response.text())
  }
  return await response.json()
}
export const putV1PurchaseTermsAndConditionsId: Api['putV1PurchaseTermsAndConditionsId'] = async (request: Types.PutV1PurchaseTermsAndConditionsIdRequest): Promise<Types.PutV1PurchaseTermsAndConditionsIdResponses> => {
  return await _putV1PurchaseTermsAndConditionsId(baseUrl, request)
}
const _deleteV1PurchaseTermsAndConditionsId = async (url: string, request: Types.DeleteV1PurchaseTermsAndConditionsIdRequest): Promise<Types.DeleteV1PurchaseTermsAndConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }
  const response = await fetch(`${url}/v1/purchase-terms-and-conditions/${request['id']}`, {
    method: 'DELETE',
    headers
  })
  if (!response.ok) {
    throw new Error(await response.text())
  }
  return await response.json()
}
export const deleteV1PurchaseTermsAndConditionsId: Api['deleteV1PurchaseTermsAndConditionsId'] = async (request: Types.DeleteV1PurchaseTermsAndConditionsIdRequest): Promise<Types.DeleteV1PurchaseTermsAndConditionsIdResponses> => {
  return await _deleteV1PurchaseTermsAndConditionsId(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    getV1PurchaseSettings: _getV1PurchaseSettings.bind(url, ...arguments),
    patchV1PurchaseSettingsId: _patchV1PurchaseSettingsId.bind(url, ...arguments),
    postV1DemandPlanningSummary: _postV1DemandPlanningSummary.bind(url, ...arguments),
    postV1DemandPlanningDetail: _postV1DemandPlanningDetail.bind(url, ...arguments),
    postV1DemandPlanningDemand: _postV1DemandPlanningDemand.bind(url, ...arguments),
    postV1DemandPlanningMaterials: _postV1DemandPlanningMaterials.bind(url, ...arguments),
    postV1DemandPlanningGenerateExcel: _postV1DemandPlanningGenerateExcel.bind(url, ...arguments),
    postV1PurchaseRequests: _postV1PurchaseRequests.bind(url, ...arguments),
    getV1PurchaseRequests: _getV1PurchaseRequests.bind(url, ...arguments),
    postV1PurchaseRequestsSaveDraft: _postV1PurchaseRequestsSaveDraft.bind(url, ...arguments),
    getV1PurchaseRequestsId: _getV1PurchaseRequestsId.bind(url, ...arguments),
    putV1PurchaseRequestsId: _putV1PurchaseRequestsId.bind(url, ...arguments),
    deleteV1PurchaseRequestsId: _deleteV1PurchaseRequestsId.bind(url, ...arguments),
    patchV1PurchaseRequestsStatusId: _patchV1PurchaseRequestsStatusId.bind(url, ...arguments),
    postV1PurchaseRequestsAddApprover: _postV1PurchaseRequestsAddApprover.bind(url, ...arguments),
    putV1PurchaseRequestsApprovalStatusId: _putV1PurchaseRequestsApprovalStatusId.bind(url, ...arguments),
    postV1PurchaseRequestsItems: _postV1PurchaseRequestsItems.bind(url, ...arguments),
    getV1PurchaseRequestsItemsId: _getV1PurchaseRequestsItemsId.bind(url, ...arguments),
    putV1PurchaseRequestsItemsId: _putV1PurchaseRequestsItemsId.bind(url, ...arguments),
    deleteV1PurchaseRequestsItemsId: _deleteV1PurchaseRequestsItemsId.bind(url, ...arguments),
    getV1PurchaseRequestsGenerateExcel: _getV1PurchaseRequestsGenerateExcel.bind(url, ...arguments),
    postV1PurchaseRequestsImport: _postV1PurchaseRequestsImport.bind(url, ...arguments),
    postV1PurchaseAgreements: _postV1PurchaseAgreements.bind(url, ...arguments),
    getV1PurchaseAgreements: _getV1PurchaseAgreements.bind(url, ...arguments),
    postV1PurchaseAgreementsSaveDraft: _postV1PurchaseAgreementsSaveDraft.bind(url, ...arguments),
    getV1PurchaseAgreementsId: _getV1PurchaseAgreementsId.bind(url, ...arguments),
    putV1PurchaseAgreementsId: _putV1PurchaseAgreementsId.bind(url, ...arguments),
    deleteV1PurchaseAgreementsId: _deleteV1PurchaseAgreementsId.bind(url, ...arguments),
    patchV1PurchaseAgreementsStatusId: _patchV1PurchaseAgreementsStatusId.bind(url, ...arguments),
    postV1PurchaseAgreementsAddApprover: _postV1PurchaseAgreementsAddApprover.bind(url, ...arguments),
    putV1PurchaseAgreementsApprovalStatusId: _putV1PurchaseAgreementsApprovalStatusId.bind(url, ...arguments),
    postV1PurchaseAgreementsItems: _postV1PurchaseAgreementsItems.bind(url, ...arguments),
    getV1PurchaseAgreementsItemsId: _getV1PurchaseAgreementsItemsId.bind(url, ...arguments),
    putV1PurchaseAgreementsItemsId: _putV1PurchaseAgreementsItemsId.bind(url, ...arguments),
    deleteV1PurchaseAgreementsItemsId: _deleteV1PurchaseAgreementsItemsId.bind(url, ...arguments),
    getV1PurchaseAgreementsGenerateExcel: _getV1PurchaseAgreementsGenerateExcel.bind(url, ...arguments),
    postV1PurchaseAgreementsImport: _postV1PurchaseAgreementsImport.bind(url, ...arguments),
    postV1Rfq: _postV1Rfq.bind(url, ...arguments),
    getV1Rfq: _getV1Rfq.bind(url, ...arguments),
    postV1RfqSaveDraft: _postV1RfqSaveDraft.bind(url, ...arguments),
    getV1RfqResponseItems: _getV1RfqResponseItems.bind(url, ...arguments),
    putV1RfqId: _putV1RfqId.bind(url, ...arguments),
    getV1RfqId: _getV1RfqId.bind(url, ...arguments),
    deleteV1RfqId: _deleteV1RfqId.bind(url, ...arguments),
    patchV1RfqIdStatus: _patchV1RfqIdStatus.bind(url, ...arguments),
    postV1RfqItems: _postV1RfqItems.bind(url, ...arguments),
    getV1RfqItemsId: _getV1RfqItemsId.bind(url, ...arguments),
    putV1RfqItemsId: _putV1RfqItemsId.bind(url, ...arguments),
    deleteV1RfqItemsId: _deleteV1RfqItemsId.bind(url, ...arguments),
    postV1RfqTender: _postV1RfqTender.bind(url, ...arguments),
    deleteV1RfqTenderId: _deleteV1RfqTenderId.bind(url, ...arguments),
    postV1RfqIdResponse: _postV1RfqIdResponse.bind(url, ...arguments),
    getV1RfqIdResponse: _getV1RfqIdResponse.bind(url, ...arguments),
    postV1RfqIdResponseSaveDraft: _postV1RfqIdResponseSaveDraft.bind(url, ...arguments),
    putV1RfqIdResponseResponseId: _putV1RfqIdResponseResponseId.bind(url, ...arguments),
    getV1RfqIdResponseResponseId: _getV1RfqIdResponseResponseId.bind(url, ...arguments),
    deleteV1RfqIdResponseResponseId: _deleteV1RfqIdResponseResponseId.bind(url, ...arguments),
    getV1RfqIdResponseResponseIdItemsItemId: _getV1RfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    putV1RfqIdResponseResponseIdItemsItemId: _putV1RfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    deleteV1RfqIdResponseResponseIdItemsItemId: _deleteV1RfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    postV1RfqIdAnalyze: _postV1RfqIdAnalyze.bind(url, ...arguments),
    postV1RfqIdAnalyzePreviousPrices: _postV1RfqIdAnalyzePreviousPrices.bind(url, ...arguments),
    postV1RfqIdAward: _postV1RfqIdAward.bind(url, ...arguments),
    getV1RfqIdSendEmail: _getV1RfqIdSendEmail.bind(url, ...arguments),
    getV1RfqIdDownload: _getV1RfqIdDownload.bind(url, ...arguments),
    getV1RfqIdProvidePoDetails: _getV1RfqIdProvidePoDetails.bind(url, ...arguments),
    getV1RfqIdProvideAgreementDetails: _getV1RfqIdProvideAgreementDetails.bind(url, ...arguments),
    getV1RfqGenerateExcel: _getV1RfqGenerateExcel.bind(url, ...arguments),
    postV1RfqImport: _postV1RfqImport.bind(url, ...arguments),
    postV1DeliveryOrders: _postV1DeliveryOrders.bind(url, ...arguments),
    getV1DeliveryOrders: _getV1DeliveryOrders.bind(url, ...arguments),
    postV1DeliveryOrdersSaveDraft: _postV1DeliveryOrdersSaveDraft.bind(url, ...arguments),
    getV1DeliveryOrdersId: _getV1DeliveryOrdersId.bind(url, ...arguments),
    deleteV1DeliveryOrdersId: _deleteV1DeliveryOrdersId.bind(url, ...arguments),
    putV1DeliveryOrdersId: _putV1DeliveryOrdersId.bind(url, ...arguments),
    patchV1DeliveryOrdersStatusId: _patchV1DeliveryOrdersStatusId.bind(url, ...arguments),
    getV1DeliveryOrdersItemsId: _getV1DeliveryOrdersItemsId.bind(url, ...arguments),
    putV1DeliveryOrdersItemsId: _putV1DeliveryOrdersItemsId.bind(url, ...arguments),
    deleteV1DeliveryOrdersItemsId: _deleteV1DeliveryOrdersItemsId.bind(url, ...arguments),
    postV1DeliveryOrdersPackages: _postV1DeliveryOrdersPackages.bind(url, ...arguments),
    getV1DeliveryOrdersPackagesId: _getV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    putV1DeliveryOrdersPackagesId: _putV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    deleteV1DeliveryOrdersPackagesId: _deleteV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    getV1DeliveryOrdersIdPackages: _getV1DeliveryOrdersIdPackages.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdPackages: _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    getV1DeliveryOrdersDeliveryIdItemsItemIdPackages: _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId: _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdTracking: _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment: _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment.bind(url, ...arguments),
    getV1DeliveryOrdersIdSendEmail: _getV1DeliveryOrdersIdSendEmail.bind(url, ...arguments),
    getV1DeliveryOrdersIdDownload: _getV1DeliveryOrdersIdDownload.bind(url, ...arguments),
    getV1DeliveryOrdersGenerateExcel: _getV1DeliveryOrdersGenerateExcel.bind(url, ...arguments),
    postV1Vra: _postV1Vra.bind(url, ...arguments),
    getV1Vra: _getV1Vra.bind(url, ...arguments),
    postV1VraSaveDraft: _postV1VraSaveDraft.bind(url, ...arguments),
    getV1VraId: _getV1VraId.bind(url, ...arguments),
    deleteV1VraId: _deleteV1VraId.bind(url, ...arguments),
    putV1VraId: _putV1VraId.bind(url, ...arguments),
    patchV1VraStatusId: _patchV1VraStatusId.bind(url, ...arguments),
    postV1VraAddApprover: _postV1VraAddApprover.bind(url, ...arguments),
    putV1VraApprovalStatusId: _putV1VraApprovalStatusId.bind(url, ...arguments),
    getV1VraItemsId: _getV1VraItemsId.bind(url, ...arguments),
    putV1VraItemsId: _putV1VraItemsId.bind(url, ...arguments),
    deleteV1VraItemsId: _deleteV1VraItemsId.bind(url, ...arguments),
    postV1VraItems: _postV1VraItems.bind(url, ...arguments),
    getV1VraIdCreateDebitNote: _getV1VraIdCreateDebitNote.bind(url, ...arguments),
    getV1VraIdSendEmail: _getV1VraIdSendEmail.bind(url, ...arguments),
    getV1VraIdDownload: _getV1VraIdDownload.bind(url, ...arguments),
    getV1VraGenerateExcel: _getV1VraGenerateExcel.bind(url, ...arguments),
    postV1VraImport: _postV1VraImport.bind(url, ...arguments),
    postV1PurchaseOrders: _postV1PurchaseOrders.bind(url, ...arguments),
    getV1PurchaseOrders: _getV1PurchaseOrders.bind(url, ...arguments),
    postV1PurchaseOrdersSaveDraft: _postV1PurchaseOrdersSaveDraft.bind(url, ...arguments),
    getV1PurchaseOrdersId: _getV1PurchaseOrdersId.bind(url, ...arguments),
    putV1PurchaseOrdersId: _putV1PurchaseOrdersId.bind(url, ...arguments),
    deleteV1PurchaseOrdersId: _deleteV1PurchaseOrdersId.bind(url, ...arguments),
    patchV1PurchaseOrdersIdStatus: _patchV1PurchaseOrdersIdStatus.bind(url, ...arguments),
    postV1PurchaseOrdersAddApprover: _postV1PurchaseOrdersAddApprover.bind(url, ...arguments),
    putV1PurchaseOrdersApprovalStatusId: _putV1PurchaseOrdersApprovalStatusId.bind(url, ...arguments),
    postV1PurchaseOrdersItems: _postV1PurchaseOrdersItems.bind(url, ...arguments),
    getV1PurchaseOrdersItemsId: _getV1PurchaseOrdersItemsId.bind(url, ...arguments),
    putV1PurchaseOrdersItemsId: _putV1PurchaseOrdersItemsId.bind(url, ...arguments),
    deleteV1PurchaseOrdersItemsId: _deleteV1PurchaseOrdersItemsId.bind(url, ...arguments),
    postV1PurchaseOrdersExpenses: _postV1PurchaseOrdersExpenses.bind(url, ...arguments),
    getV1PurchaseOrdersExpensesId: _getV1PurchaseOrdersExpensesId.bind(url, ...arguments),
    putV1PurchaseOrdersExpensesId: _putV1PurchaseOrdersExpensesId.bind(url, ...arguments),
    deleteV1PurchaseOrdersExpensesId: _deleteV1PurchaseOrdersExpensesId.bind(url, ...arguments),
    postV1PurchaseOrdersIdGrn: _postV1PurchaseOrdersIdGrn.bind(url, ...arguments),
    getV1PurchaseOrdersIdGrn: _getV1PurchaseOrdersIdGrn.bind(url, ...arguments),
    putV1PurchaseOrdersIdGrnGrnId: _putV1PurchaseOrdersIdGrnGrnId.bind(url, ...arguments),
    getV1PurchaseOrdersIdGrnGrnId: _getV1PurchaseOrdersIdGrnGrnId.bind(url, ...arguments),
    deleteV1PurchaseOrdersIdGrnGrnId: _deleteV1PurchaseOrdersIdGrnGrnId.bind(url, ...arguments),
    getV1PurchaseOrdersIdGrnGrnIdDownload: _getV1PurchaseOrdersIdGrnGrnIdDownload.bind(url, ...arguments),
    getV1PurchaseOrdersIdGrnGrnIdItemItemId: _getV1PurchaseOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    putV1PurchaseOrdersIdGrnGrnIdItemItemId: _putV1PurchaseOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    deleteV1PurchaseOrdersIdGrnGrnIdItemItemId: _deleteV1PurchaseOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking: _postV1PurchaseOrdersIdGrnGrnIdItemsItemIdTracking.bind(url, ...arguments),
    postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment: _postV1PurchaseOrdersIdGrnGrnIdInventoryAdjustment.bind(url, ...arguments),
    getV1PurchaseOrdersIdCreateBill: _getV1PurchaseOrdersIdCreateBill.bind(url, ...arguments),
    getV1PurchaseOrdersReceipts: _getV1PurchaseOrdersReceipts.bind(url, ...arguments),
    getV1PurchaseOrdersIdSendEmail: _getV1PurchaseOrdersIdSendEmail.bind(url, ...arguments),
    getV1PurchaseOrdersIdDownload: _getV1PurchaseOrdersIdDownload.bind(url, ...arguments),
    getV1PurchaseOrdersOrderIdGrnIdScrap: _getV1PurchaseOrdersOrderIdGrnIdScrap.bind(url, ...arguments),
    getV1PurchaseOrdersGenerateExcel: _getV1PurchaseOrdersGenerateExcel.bind(url, ...arguments),
    postV1PurchaseOrdersImport: _postV1PurchaseOrdersImport.bind(url, ...arguments),
    postV1LandingCost: _postV1LandingCost.bind(url, ...arguments),
    getV1LandingCost: _getV1LandingCost.bind(url, ...arguments),
    postV1LandingCostCompute: _postV1LandingCostCompute.bind(url, ...arguments),
    getV1LandingCostId: _getV1LandingCostId.bind(url, ...arguments),
    putV1LandingCostId: _putV1LandingCostId.bind(url, ...arguments),
    deleteV1LandingCostId: _deleteV1LandingCostId.bind(url, ...arguments),
    postV1LandingCostItems: _postV1LandingCostItems.bind(url, ...arguments),
    getV1LandingCostItemsId: _getV1LandingCostItemsId.bind(url, ...arguments),
    putV1LandingCostItemsId: _putV1LandingCostItemsId.bind(url, ...arguments),
    deleteV1LandingCostItemsId: _deleteV1LandingCostItemsId.bind(url, ...arguments),
    postV1LandingCostValidate: _postV1LandingCostValidate.bind(url, ...arguments),
    getV1LandingCostGenerateExcel: _getV1LandingCostGenerateExcel.bind(url, ...arguments),
    postV1LandingCostImport: _postV1LandingCostImport.bind(url, ...arguments),
    postV1PurchaseTermsAndConditions: _postV1PurchaseTermsAndConditions.bind(url, ...arguments),
    getV1PurchaseTermsAndConditions: _getV1PurchaseTermsAndConditions.bind(url, ...arguments),
    getV1PurchaseTermsAndConditionsId: _getV1PurchaseTermsAndConditionsId.bind(url, ...arguments),
    putV1PurchaseTermsAndConditionsId: _putV1PurchaseTermsAndConditionsId.bind(url, ...arguments),
    deleteV1PurchaseTermsAndConditionsId: _deleteV1PurchaseTermsAndConditionsId.bind(url, ...arguments)
  }
}